import { render, staticRenderFns } from "./deviceStatus.vue?vue&type=template&id=dc97f644&scoped=true"
import script from "./deviceStatus.vue?vue&type=script&lang=ts"
export * from "./deviceStatus.vue?vue&type=script&lang=ts"
import style0 from "./deviceStatus.vue?vue&type=style&index=0&id=dc97f644&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc97f644",
  null
  
)

export default component.exports